/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {Autocomplete} from '@material-ui/lab';
import {translate} from '@ion/core/src/locale/locale';
import {IconButton} from '@ion/dls/src/components/buttons/IconButton';
import {MaterialExitCloseIcon} from '@ion/dls/src/icons/MaterialExitCloseIcon';
import {TopNavSearchIcon} from '@ion/dls/src/icons/TopNavSearchIcon';
import TextField from '../../components/textfield/TextField';
import {useStyles} from '../Filter';

export interface GroupsSearchProps {
  classes: any;
  options: any[];
  onOptionSelect: (event, value) => void;
  onSearchInputChange: (event, value, reason) => void;
  onSearchChange: Function;
  openSearch: () => void;
  closeSearch: () => void;
  openFilterSearch: boolean;
}

export const GroupsSearch = memo(({
  options,
  onOptionSelect,
  onSearchInputChange,
  onSearchChange,
  openSearch,
  closeSearch,
  openFilterSearch
}: GroupsSearchProps) => {
  const classes = useStyles();

  if (openFilterSearch) {
    return (
      <Autocomplete classes={{root: classes.autoCoompleteRoot, popper: classes.popper}}
        options={options}
        onChange={onOptionSelect}
        onInputChange={onSearchInputChange}
        noOptionsText={translate('reports:filters.nooptiontext')}
        renderInput={function(params: any) {
          return (
            <TextField {...params}
              onChange={onSearchChange}
              placeholder={translate('reports:filters.searchgroups')}
              InputProps={{
                ...params.InputProps,
                endAdornment : (
                  <IconButton icon={<MaterialExitCloseIcon />}
                    onClick={closeSearch}
                    size='small'
                    disableRipple />
                )
              }}
              autoFocus />
          );
        }}
        getOptionLabel={function(option) {
          return option?.title;
        }}/>
    );
  }
  return (
    <div className={classes.filterSelectWrapper}>
      <IconButton disableRipple
        style={{padding: '9px 9px 8px 9px'}}
        onClick={openSearch}
        icon={<TopNavSearchIcon />} />
    </div>
  );
});
